export default function PageIntro({ eyebrow, title, lead, children, testId }) {
  return (
    <header data-testid={testId} className="mx-auto max-w-6xl px-5 pb-12 pt-36 lg:px-8 lg:pb-16 lg:pt-36">
      <div className="max-w-2xl">
        {eyebrow && <p className="mb-3 text-xs uppercase tracking-[0.25em] text-[#8B5CF6]">{eyebrow}</p>}
        <h1 className="font-display text-4xl font-bold tracking-tighter text-white sm:text-5xl">{title}</h1>
        {lead && <p className="mt-5 text-base leading-relaxed text-white/60 md:text-lg">{lead}</p>}
        {children}
      </div>
      <div className="mt-12 h-px w-full bg-white/10 lg:mt-16" />
    </header>
  );
}

export function SectionHeading({ eyebrow, title, lead, align = "left" }) {
  return (
    <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <p className="mb-3 text-xs uppercase tracking-[0.25em] text-[#8B5CF6]">{eyebrow}</p>}
      <h2 className="font-display text-3xl font-bold tracking-tighter text-white sm:text-4xl">{title}</h2>
      {lead && <p className="mt-4 text-base leading-relaxed text-white/60">{lead}</p>}
    </div>
  );
}
